
import { Base } from '../../components/base-component';

import './calculators-personalloans-v2.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import { ValidationService } from '../../services/validation.service';
import { CalculatorService } from '../../services/calculator.service';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from 'jquery';

export class CalculatorsPersonalloansV2 extends Base {

	timeout: any = null;

	inputs: Element[];

	expensesModal: Element[];

	calculatorSubmit: Element[];
	calculatorReset: Element[];
	calculator: HTMLFormElement;

	copyFields: Element[];

	modalLinks: Element[];

	formValid: boolean = true;

	termChecker: HTMLFormElement[];

	modifiers: Element[];
	modifierToggles: Element[];
	modifiersRadiosToggle: Element[];

	addonToggles: Element[];

	validationService: ValidationService;
	calculatorService: CalculatorService;

	copyFieldTimeout: any;

	constructor(element: Element,
		analyticsService: AnalyticsService) {
		super(element);
	}

	init() {
		
		this.inputs = Array.from(this.element.querySelectorAll('input'));

		this.modifiers = Array.from(this.element.querySelectorAll('.js-calculator-modifier'));
		this.modifierToggles = Array.from(this.element.querySelectorAll('.js-calculator-modifier-toggle'));
		this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-calculator-radio-group'));

		this.addonToggles = Array.from(this.element.querySelectorAll('.js-calculator-addon-toggle'));

		this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-personalloans-v2-calculate'));
		this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
		this.calculator = this.element.querySelector('form') as HTMLFormElement;

		this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));

		this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));

		this.termChecker = Array.from(this.element.querySelectorAll("select[name=term]"));

		TooltipsService.initTooltips();
	}

	bindEvents() {

		let buttonSteps = Array.from(this.element.querySelectorAll('.accordion span.calculator-personalloans-v2-form__button-step'));
		buttonSteps.forEach(element => {
			element.parentElement.removeChild(element);
		});

		this.calculatorSubmit.map((item) => item.addEventListener('click', (event) => {
			// animate back to top
			let btnDoIQualify = Array.from(this.element.querySelectorAll('.js-calculator-do-i-qualify'));

			if ($(window).width() > 768) {
				$('html,body').animate({
					scrollTop: $('div.calculators').offset().top - 10
				}, 'slow');

				btnDoIQualify.forEach(element => {
					element.classList.remove('button--white');
					element.classList.remove('button--border-blue');
					element.classList.add('gradient-orange');
				});
			} else if ($(window).width() < 768) {
				$('html,body').animate({
					scrollTop: $('div.calculator-personalloans-v2-item__box').offset().top
				}, 'slow');
				
				setTimeout(function(){ 
					btnDoIQualify.forEach(element => {
						element.classList.remove('button--white');
						element.classList.remove('button--border-blue');
						element.classList.add('gradient-orange');
					});
				}, 800);
			}
			const allFields: any = this.calculator.querySelectorAll('input');
			if (this.formValid) {
				const button : any = event.currentTarget;

				const form =  button.closest("form");

				this.doPLT(form)
				// Analytics - Trigger form Complete when the user calculates the results
				this.analyticsService.dtmFormComplete("complete", "");
			}
		}));

		this.modifiersRadiosToggle.map((item) => item.addEventListener('click', (event: any) => {
			let targetField = event.target;
			let visibleGroups = Array.from(this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
			let radioContainers = Array.from(this.element.querySelectorAll('.js-calculator-radio-group-containers'));
			radioContainers.map((item) => {
				item.classList.add('calculator-personalloans-v2-form__hidden');
				let inputs = Array.from(item.querySelectorAll('input'));
				inputs.map((item: any) => {
					let getDefaultValue = item.value;
					if (!getDefaultValue == undefined || getDefaultValue == '') {
						item.value = '';
					} else {
						item.value = getDefaultValue;
					}
				});
			});
			visibleGroups.map((item) => {
				item.classList.remove('calculator-personalloans-v2-form__hidden');
			});
		}));

		this.calculatorReset.map((item) => item.addEventListener('click', (event) => {
			this.resetInputs(event);

			// animate back to top
			$('html,body').animate({
				scrollTop: $('div.calculators').offset().top - 10
				},'slow');	

			let btnDoIQualify: HTMLElement[] = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));

			btnDoIQualify.forEach(element => {
				element.classList.remove('gradient-orange');
				element.classList.add('button--white');
				element.classList.add('button--border-blue');
			});
		}));

		this.modifierToggles.map((item) => item.addEventListener('click', (event) => {
			this.toggleModifiers(event);
		}));

		this.addonToggles.map((item) => item.addEventListener('click', (event) => {
			this.toggleAddons(event);
		}));

		this.copyFields.map((item) => item.addEventListener('input', (event) => {
			this.copyField(event);
		}));

		this.copyFields.map((item) => item.addEventListener('change', (event) => {
			this.copyField(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModal(event);
		}));

		// INPUTS
		this.inputs.map((item) => item.addEventListener('focusin', (event) => {
			this.onFocusInput(event);
		}));

		this.inputs.map((item) => item.addEventListener('focusout', (event) => {
			this.outFocusInput(event);
			this.validateCalculator(event, this.calculatorSubmit);
			let _valid: Element[] = Array.from(this.element.querySelectorAll('.calculator-personalloans-v2-form__error'));

			if (_valid.length > 0) {
				this.formValid = false;
				this.calculatorSubmit.map((item) => {
					item.classList.add('button--disabled');
				});
			} else {
				this.formValid = true;
				this.calculatorSubmit.map((item) => {
					item.classList.remove('button--disabled');
				});
			}
		}));

		this.inputs.map((item) => item.addEventListener('keyup', (event) => {
			this.keyInput(event);
		}));

		if (this.termChecker) {
			this.termChecker.map((item) => item.addEventListener('change', (event) => {
				this.checkBaloonPayments(event);
			}));
		}

	}

	openModal(event) {

		let modalId = event.currentTarget.parentNode.getAttribute('data-modal');

		this.event.emit('openModal', {
			id: modalId
		});

	}

	copyField(event) {
		let fieldParentContainer = this.findFieldCopy(event.currentTarget.parentNode);
		let copyValue = parseFloat(event.currentTarget.value);
		let fieldName = fieldParentContainer.getAttribute('data-target');
		let fields = fieldParentContainer.querySelectorAll(`.js-${fieldName}`);

		for (let i = 0; i < fields.length; i++) {
			if (fields[i].classList.contains('js-not-zero')) {
				if (copyValue == 0) {
					copyValue = 1;
				}
			}
			fields[i].value = copyValue;
		}
		// Form form start (if not started yet) when slider is being interacted with
		this.analyticsService.dtmTriggerFormStart(fields[0]);

	}

	findFieldCopy(parent) {
		while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'));
		return parent;
	}

	toggleModifiers(event) {

		event.preventDefault();

		let targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetModifier = this.element.querySelector(`#${targetModifierId}`);

		if (targetModifier.classList.contains('calculator-personalloans-v2-form__modifiers--open')) {
			targetModifier.classList.remove('calculator-personalloans-v2-form__modifiers--open');
			event.currentTarget.classList.add('calculator-personalloans-v2-form__link--open');
		} else {
			targetModifier.classList.add('calculator-personalloans-v2-form__modifiers--open');
			event.currentTarget.classList.remove('calculator-personalloans-v2-form__link--open');
		}

	}

	toggleAddons(event) {

		event.preventDefault();

		if (event.currentTarget.classList.contains('link--disabled')) {
			return;
		}

		let targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetAddon = this.element.querySelector('#' + targetAddonId);

		let targetInput = targetAddon.querySelector("input");

		const _tmpText = event.currentTarget.querySelector(".link__text") as HTMLFormElement;
		const _coAppText = this.element.querySelector(".co_app_text") as HTMLFormElement;

		if (targetAddon.classList.contains("calculator-personalloans-v2-form__addon--open")) {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.remove('calculator-personalloans-v2-form__addon--open');
			_tmpText.innerText = "+ Add co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "";
			}
		} else {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.add('calculator-personalloans-v2-form__addon--open');
			_tmpText.innerText = "- Remove co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "(including co-applicant)";
			}
		}
	}

	resetInputs(event) {
		event.preventDefault();

		let errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
		errorLabels.map((item: any) => {
			let parent: any = item;
			$(parent).removeClass('calculator-personalloans-v2-form__error');
			$(parent).find('div.calculator-personalloans-v2-form__error-label').remove();
		});

		this.calculator.reset();
		this.formValid = true;
		this.resetValues(this.calculator);

		this.inputs.map((item: any) => {
			if (item.getAttribute('type') != 'radio') {
				item.setAttribute('data-value', 0);
				item.setAttribute('placeholder', 0);
			}
		});

		// Analytics - Trigger form Complete when the user calculates the results
		this.analyticsService.dtmRestartForm();

	}

	onFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;
		let _value = parseFloat(field.value);
		let min = parseFloat(field.getAttribute('min'));
		let max = parseFloat(field.getAttribute('max'));
		if (min && max) {
			if ((_value < min) && (_value > max)) {
				field.value = "";
			}
		} else {
			if (_value == 0) {
				field.value = "";
			}
		}
	}

	outFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;

		if (!field.classList.contains('js-copy-field')) {
			let value = field.getAttribute('data-value');
			// field.value = value;
			if (field.value == '') {
				field.value = value;
			}
		}

		if (field.value == '') {
			field.value = 0;
		}
	}

	keyInput(event) {
		event.preventDefault();
		this.formValid = true;
		let field: any = event.target;
		let value = field.value;

		if (!field.classList.contains('js-copy-field')) {
			field.setAttribute('data-value', value);
			field.setAttribute('placeholder', value);
		}

		this.formValid = this.validateCalculator(event, this.calculatorSubmit);
	}

	checkBaloonPayments(event) {
		let value = event.currentTarget.value;

		let balloonInput: HTMLFormElement[] = Array.from(this.element.querySelectorAll(".js-balloon"));

		if (balloonInput.length > 0) {
			if (value == '84') {
				balloonInput.forEach(element => {
					element.value = "0";
					element.placeholder = "0";
					element.max = "0";
					element.min = "0";
					element.setAttribute("data-value", "0");
				});
			} else {
				balloonInput.forEach(element => {
					element.value = "1";
					element.placeholder = "1";
					element.max = "40";
					element.min = "1";
					element.setAttribute("data-value", "1");
				});
			}
		}
	}

	//CALCULATOR SERVICES
	doPLT(form: HTMLFormElement) {
		let total: number = 0;
		const loanamount: any = form.querySelector('input[name=loan_amount]');
		total = parseFloat(loanamount.value)
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_borrow: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
		const output_months: any = document.querySelectorAll('span.js-calculator-loan-period-pl1');
		const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
		const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-pl1');

		const answer = this.PLTMonthlyRepayments(total, interest.value, term.value);

		[].slice.call(output_borrow).forEach(function (div) {
			div.innerHTML = answer.estimatedMonthlyRepayment;
		});
		[].slice.call(output_date).forEach(function (div) {
			div.innerHTML = answer.date;
		});
		[].slice.call(output_fees).forEach(function (div) {
			div.innerHTML = answer.totalInterest;
		});

		
	}

	// PERSONAL LOANS
	PLTMonthlyRepayments(
		loanamount: number = 0,
		loaninterest: number = 0,
		loanterm: number = 10.25
	) {
		const initiationFee: number = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
		const serviceFee: number = 60 * 1.15;

		let normalValue: number = loanamount / loanterm;
		normalValue = this.round(normalValue, 2);

		let final: number = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
		final = this.round(final, 2);

		let interestTotal: number = this.round((final - normalValue), 2);

		let todaysDate: any = new Date();
		let getMonth: number = todaysDate.getMonth();
		todaysDate.setMonth(getMonth + 1, 1);
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		return {
			date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
			iFee: initiationFee,
			sFee: serviceFee,
			totalInterest: this.formatter(interestTotal),
			estimatedMonthlyRepayment: this.formatter(final)
		};
	}

	round(expr, decplaces) {
		let decpoint, str;
		str = '' + Math.round(expr * Math.pow(10, decplaces));
		while (str.length <= decplaces) {
			str = '0' + str;
		}
		decpoint = str.length - decplaces;
		return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
	}

	pmt_vaf(rate: number = 0, period: number = 0, value: number = 0, futurevalue: number = 0, type: number = 0) {
		if (!futurevalue) futurevalue = 0;
		if (!type) type = 0;

		if (rate == 0) return -(value + futurevalue) / period;

		var pvif = Math.pow(1 + rate, period);
		var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);

		if (type == 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	}

	// FORMATTERS
	formatter(value) {
		return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
	}

	// RESET VALUES	- OUTPUTS
	resetValues(form: HTMLFormElement) {
		switch (form.id) {

			case 'calculator-personal_loans_v2':
				const loanamount: any = form.querySelector('input[name=loan_amount]');
				const output_borrow_plt: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
				const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
				const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-pl1');
				[].slice.call(loanamount).forEach(function (div) {
					div.innerHTML = '300000';
				});
				[].slice.call(output_borrow_plt).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_date).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_fees).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			default:
				break;
		}
	}

	//
	//
	// PERSONAL LOANS CUSTOM CALCULATOR VALIDATIONS
	//
	//
	validateCalculator(event: any, button: any) {

		// varaibles
		event.preventDefault();
		let field = event.target;
		let formValid = true;
		let fieldValue = field.value;
		let fieldAddon = field;
		let required: any = field.getAttribute('data-validation-required');
		let title: any = field.getAttribute('data-validation-title');
		let minimum: any = parseFloat(field.getAttribute('min'));
		let maximum: any = parseFloat(field.getAttribute('max'));
		let greaterThan: any = field.getAttribute('data-validation-greater-than');
		let lessThan: any = field.getAttribute('data-validation-less-than');

		// removeErrors
		$(field).closest('.calculator-personalloans-v2-form__group').removeClass('calculator-personalloans-v2-form__error');
		$(field).closest('.calculator-personalloans-v2-form__group').find('div.calculator-personalloans-v2-form__error-label').remove();

		// required
		if (required == "true") {
			if (fieldValue.length == 0) {
				formValid = false;
				if (minimum) {
					if (maximum) {
						if (title) {
							this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
						} else {
							this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
						}
					} else {
						this.validateCalculatorError(event, 'Enter an amount');
					}
				} else {
					this.validateCalculatorError(event, 'Enter an amount');
				}
			}
		}

		// min
		if (minimum > parseFloat(fieldValue)) {
			formValid = false;
			if (title && maximum) {
				this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
			} else if (!title && maximum) {
				this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
			} else if (!title && !maximum) {
				this.validateCalculatorError(event, 'Enter an amount');
			}
		}

		// max
		if (maximum > 0) {
			if (maximum < parseFloat(fieldValue)) {
				formValid = false;
				if (title) {
					this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
				} else {
					this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
				}
			}
		} else {
			if (maximum < parseFloat(fieldValue)) {
				formValid = false;
				if (title) {
					this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
				} else {
					this.validateCalculatorError(event, 'The maximum you can insert is 0');
				}
			}
		}

		// greater than
		if (greaterThan) {
			let fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
			if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
				formValid = false;
				this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
			}
		}

		// less than
		if (lessThan) {
			let fieldsLessThan: any = $(field).closest('form').find('input[name=' + lessThan + ']');
			if (fieldsLessThan.length > 1) {
				let amount: number = 0;
				$(fieldsLessThan).each(function (index) {
					let valueElement: any = $(this).val();
					if (!valueElement) {
						amount = amount + 0;
					} else {
						amount = amount + parseFloat(valueElement);
					}
				});
				if (parseFloat(fieldValue) >= amount) {
					formValid = false;
					this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
				}
			} else {
				if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
					formValid = false;
					this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
				}
			}
		}
		return formValid;

	}

	validateCalculatorError(event: any, message = '') {
		event.preventDefault();
		let field: any = event.target;
		let closestGroup = field.closest('.calculator-personalloans-v2-form__group');
		$(closestGroup).addClass('calculator-personalloans-v2-form__error').append('<div class="calculator-personalloans-v2-form__error-label">' + message + '</div>');
	}

	formatNumbers(nStr: any) {
		nStr += '';
		let x = nStr.split('.');
		let x1 = x[0];
		let x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ' ' + '$2');
		}
		return x1 + x2;

	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/calculators-personalloans-v2/calculators-personalloans-v2.component.ts